import { MaintenanceWindowSimpleSchedulerController } from '../controller/MaintenanceWindowSimpleSchedulerController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MaintenanceWindowSimpleSchedulerSchema } from '../types';

export class MaintenanceWindowSimpleSchedulerWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowSimpleSchedulerController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowSimpleSchedulerController,
    });
  }

  get isVisible(): boolean {
    return this.hasAttribute('data-is-visible');
  }

  set isVisible(value: boolean) {
    if (value) {
      this.setAttribute('data-is-visible', 'true');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  get hasImmediatelyOption(): boolean {
    return this.hasAttribute('data-has-immediately');
  }

  set hasImmediatelyOption(value: boolean) {
    if (value) {
      this.setAttribute('data-has-immediately', 'true');
    } else {
      this.removeAttribute('data-has-immediately');
    }
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');

    return attributeValue !== null;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
    this.controller?.view.setDisabledInnerComponents(value);
  }

  get viewData(): MaintenanceWindowSimpleSchedulerSchema | any {
    const attributeValue = this.getAttribute('data-view-data');

    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  set viewData(value: MaintenanceWindowSimpleSchedulerSchema) {
    this.setAttribute('data-view-data', JSON.stringify(value));
    this.controller?.render();
  }

  public setTitle(value: string) {
    this.controller?.view.setTitle(value);
  }
}
